import type { FC } from 'react'
import React, { useState, useEffect, useCallback } from 'react'
import debounce from 'lodash.debounce'
import type { StandardTextFieldProps } from '@material-ui/core'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

import TextField from '../TextField'
import { usePrevious } from '@homeviews/hooks'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& .MuiFormControl-root': {
        marginBottom: 0,
      },
      '& .MuiInputBase-root': {
        borderRadius: 8,
        fontWeight: 500,
      },
    },
  }),
)

interface IProps extends StandardTextFieldProps {
  value: string
  withDebounce?: boolean
  className?: string
}

const SearchInput: FC<IProps> = ({
  className,
  value,
  onChange,
  withDebounce,
}) => {
  const [localValue, setLocalValue] = useState<any>('')
  const prevValue = usePrevious(value)
  const classes = useStyles()

  useEffect(() => {
    if (value !== localValue && prevValue !== value) {
      setLocalValue(value)
    }
  }, [value, localValue, prevValue])

  const callback = useCallback(
    debounce(
      (newValue: any) => {
        onChange(newValue)
      },
      withDebounce ? 400 : 1,
    ),
    [],
  )

  return (
    <div className={clsx(classes.root, className)}>
      <TextField
        value={localValue}
        placeholder="Search"
        onChange={(e) => {
          const newValue = e.target.value
          setLocalValue(newValue)
          callback(newValue)
        }}
      />
    </div>
  )
}

export default SearchInput
